var _title, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeartFill = function SvgHeartFill(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "heart-fill")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 10.781c0-4.773-3.869-8.641-8.642-8.641-3.116 0-5.838 1.655-7.358 4.129-1.52-2.473-4.243-4.129-7.359-4.129-4.773 0-8.64 3.869-8.64 8.641 0 2.598 1.151 4.923 2.966 6.506l12.245 12.246c0.209 0.209 0.493 0.327 0.789 0.327s0.579-0.117 0.789-0.327l12.245-12.246c1.815-1.583 2.966-3.908 2.966-6.506z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart-fill.d012dd5a.svg";
export { ForwardRef as ReactComponent };